import React, {Fragment, useRef, useState} from 'react';
import AddIcon from '@material-ui/icons/Add';
import {useTheme} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {Form, Popup, Select, Accordion, Radio, MultipleSelect, Chip_input, Explanation_text, Date_picker} from '../../';
import ForwardIcon from '@material-ui/icons/Forward';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ImageIcon from '@material-ui/icons/Image';
import CancelIcon from '@material-ui/icons/Cancel';
import Button from '@material-ui/core/Button';
import axios from 'axios';


export default function CustomFieldsSection(props){
  const theme=useTheme();
  let spec_fields=[];
  if(props.workspace!=undefined){
    for(let wf of props.workspace.workspace_fields){
      if(wf.entity_type==props.type){spec_fields.push(wf);}
    }
  }
  let field_array_name='custom_fields';
  if(props.type=='COMPANY'){field_array_name='company_fields';}

  return(
                    <Accordion
                      style={{width:'calc(100% + 40px)', marginLeft:'-20px'}}
                      open={(props.open_section=='custom_fields')?true:false}
                      onChange={()=>{props.setOpenSection((props.open_section=='custom_fields')?undefined:'custom_fields')}}
                      content={[
                        {
                          title: (
                            <Typography style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'0px', marginBottom:'0px'}}><span style={{color:theme.palette.primary.main}}>{"Custom fields: "}</span></Typography>
                          ),
                          content:(props.force_content!=undefined)?props.force_content:(props.workspace==undefined || spec_fields.length==0)?
                          <div style={{width:'100%', height:'60px', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='secondary' onClick={()=>{window.location.href='/setup';}}>Add custom fields</Button></div>
                          : (
                            <div style={{position:'relative', width:'100%', marginTop: '-20px' }}>
                            <Grid container style={{position:'relative',width:'100%'}} >
                            {props.workspace.workspace_fields.map(function(wd){
                              if(wd.entity_type==props.type){
                              if(wd.data_type==6){return null;}
                              if((wd.availability==2 || wd.availability==3) && props.workspace.admin==false){return(null);}
                              return(
                                <Grid item xs={(props.xs==undefined)?6:props.xs} sm={(props.sm==undefined)?6:props.sm} style={{marginTop:'0px'}}>
                                    <Field name={field_array_name}>{(f)=>
                                      (wd.data_type==0 || wd.data_type==2 || wd.data_type==4 || wd.data_type==5)?
                                        <TextField size='small' variant='outlined' type={(wd.data_type==2 || wd.data_type==5)?'number':'text'} label={wd.name} value={valueOfField(f, wd.id)}
                                                   onChange={(e)=>{let new_values=[];let done=false; for(let v of f.input.value){if(v.workspace_field_id==wd.id){v.value=e.target.value; done=true;} new_values.push(v);} if(done==false){new_values.push({value:e.target.value, workspace_field_id:wd.id})} f.input.onChange(''); f.input.onChange(new_values);}}
                                                   style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}}
                                                   />
                                      :(wd.data_type==3)?
                                        <div style={{marginTop:'0px'}}>
                                          <MultipleSelect title={wd.name} select_data={wd.workspace_field_options} value={valueOfField(f, wd.id)}
                                                          onChange={(e)=>{let new_values=[];let done=false; for(let v of f.input.value){if(v.workspace_field_id==wd.id){v.value=e.target.value; done=true;} new_values.push(v);} if(done==false){new_values.push({value:e.target.value, workspace_field_id:wd.id})} f.input.onChange(''); f.input.onChange(new_values);}}
                                                          style={{marginTop:'10px'}}
                                                          />
                                        </div>
                                      :
                                      <Select first_none no_field size='small' variant='outlined' title={wd.name} value={selectIndex(wd.workspace_field_options, valueOfField(f, wd.id))}
                                              onChange={(e)=>{let target_val=null; for(let o of wd.workspace_field_options){if(o.id==e.target.value){target_val=o.name; break;}} let new_values=[];let done=false; for(let v of f.input.value){if(v.workspace_field_id==wd.id){v.value=target_val; done=true;} new_values.push(v);} if(done==false){new_values.push({value:target_val, workspace_field_id:wd.id})} f.input.onChange(''); f.input.onChange(new_values);}}
                                              style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} select_data={wd.workspace_field_options}/>

                                }</Field>
                            </Grid>)
                              }})}
                            </Grid>
                            <Grid container>
                            {props.workspace.workspace_fields.map(function(wd){
                              if(wd.entity_type==props.type){
                              if(wd.data_type!=6){return null;}

                              if((wd.availability==2 || wd.availability==3) && props.workspace.admin==false){return(null);}
                              return(
                                <Grid item xs={(props.xs==undefined)?6:props.xs} sm={(props.sm==undefined)?6:props.sm} style={{marginTop:'0px'}}>
                                    <Field name={field_array_name}>{(f)=>
                                      (wd.data_type==6)?
                                      <div style={{marginTop:'-20px'}}>
                                      <Field name={'delete.custom_field_'+wd.id}>{(fi)=>
                                        <Chip_input
                                                  title={wd.name}
                                                  value={fi.input.value}
                                                  initial_value={valueOfField(f, wd.id)}
                                                  name={'delete.custom_field_'+wd.id}
                                                  onChange={(e)=>{fi.input.onChange(e);}}
                                                  onUpdate={(e)=>{let val=[]; for(let x of e){val.push(x.text);} let new_values=[];let done=false; for(let v of f.input.value){if(v.workspace_field_id==wd.id){v.value=val; done=true;} new_values.push(v);} if(done==false){new_values.push({value:val, workspace_field_id:wd.id})} f.input.onChange(''); f.input.onChange(new_values);}}
                                                  value_name='text'/>
                                                  }</Field></div>
                                      :null}
                                </Field>
                            </Grid>)
                              }})}
                            </Grid>
                            </div>
                          ),
                        },
                      ]}
                    />


//The delete part gets wiped before submitting, and is just a placeholder for helping edit.


  )
}


//return(<Fragment><span><IconButton>{props.icons[c]}</IconButton></span><span><TextField size='small' variant='outlined' style={{width:'calc(100% - 60px)', backgroundColor:'#f7f9fc'}} label={c} onChange={(e)=>{let v=e.target.value; let new_val=f.input.value; new_val.push({company_url_type_id:index, url:v}); f.input.onChange(''); f.input.onChange(new_val)}}/></span></Fragment>)


function selectIndex(options, value){for(let o of options){if(o.name==value){return o.id;}}}

function valueOfField(f, workspace_field_id){
  for(let v of f.input.value){
    if(v.workspace_field_id==workspace_field_id){return v.value;}
  }
  return '';
}
